<template>
	<div>
		<div
			v-for="costComparison in costsComparison"
			:key="costComparison.serialNumber"
		>
			<final-report-comparison-single-cost
				v-if="costComparison.oldName"
				:old="true"
				:parent-serial-number="parentSerialNumber"
				:serial-number="costComparison.serialNumber"
				:name="costComparison.oldName"
				:cost-divisions-from-project="costComparison.oldCostDivisionsProject"
				:cost-divisions-from-documents="costComparison.oldCostDivisionsDocuments"
				:other-name="costComparison.currentName"
				:other-cost-divisions-from-project="costComparison.currentCostDivisionsProject"
				:other-cost-divisions-from-documents="costComparison.currentCostDivisionsDocuments"
			/>
			<final-report-comparison-single-cost
				v-if="costComparison.currentName"
				:old="false"
				:parent-serial-number="parentSerialNumber"
				:serial-number="costComparison.serialNumber"
				:name="costComparison.currentName"
				:cost-divisions-from-project="costComparison.currentCostDivisionsProject"
				:cost-divisions-from-documents="costComparison.currentCostDivisionsDocuments"
				:other-name="costComparison.oldName"
				:other-cost-divisions-from-project="costComparison.oldCostDivisionsProject"
				:other-cost-divisions-from-documents="costComparison.oldCostDivisionsDocuments"
			/>
		</div>
	</div>
</template>

<script>
	import FinalReportComparisonSingleCost from "./FinalReportComparisonSingleCost";

	export default {
		name: "FinalReportComparisonCosts",
		components: {FinalReportComparisonSingleCost},
		props: {
			parentSerialNumber: {},
			oldCosts: {},
			currentCosts: {}
		},

    beforeMount() {
      let comparisonResult = JSON.stringify(this.oldCosts) === JSON.stringify(this.currentCosts);
      if (comparisonResult === false) {
        this.$emit('dataDiffer');
      }
    },

    computed: {
			costsComparison () {

				let result = [];

				let findCostComparison = (serialNumber) =>
					result.find(x => x.serialNumber === serialNumber);

				let addMissingSerialNumbersInComparison = (cost) => {
					if (!findCostComparison(cost.serialNumber)) {
						result.push({serialNumber: cost.serialNumber});
					}
				};


				let fillComparisonDefaultPropertiesValues = (comparison) => {
					comparison.oldName = "";
					comparison.oldCostDivisionsProject = [];
					comparison.oldCostDivisionsDocuments = [];

					comparison.currentName = "";
					comparison.currentCostDivisionsProject = [];
					comparison.currentCostDivisionsDocuments = [];
				};

				this.oldCosts.forEach(addMissingSerialNumbersInComparison);
				this.currentCosts.forEach(addMissingSerialNumbersInComparison);
				result.forEach(fillComparisonDefaultPropertiesValues);

				let assignOldVariables =
					(cost) => {
						let comparison = findCostComparison(cost.serialNumber);
						comparison.oldCostDivisionsProject = cost.fromProject;
						comparison.oldCostDivisionsDocuments = cost.fromDocument;
						comparison.oldName = cost.name;
					};


				this.oldCosts.forEach(assignOldVariables);

				let assignCurrentVariables =
					(cost) => {
						let comparison = findCostComparison(cost.serialNumber);
						comparison.currentCostDivisionsProject = cost.fromProject;
						comparison.currentCostDivisionsDocuments = cost.fromDocument;
						comparison.currentName = cost.name;
					};

				this.currentCosts.forEach(assignCurrentVariables);

				result.sort((a, b) => a.serialNumber - b.serialNumber);

				return result;
			}
		}
	};
</script>

<style scoped>

</style>